import { render, staticRenderFns } from "./PromotionIndex.vue?vue&type=template&id=61188602&scoped=true"
import script from "./PromotionIndex.vue?vue&type=script&lang=js"
export * from "./PromotionIndex.vue?vue&type=script&lang=js"
import style0 from "./PromotionIndex.vue?vue&type=style&index=0&id=61188602&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61188602",
  null
  
)

export default component.exports